import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import LostPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'lostPasswordPanel';
const FORM_ID = 'lostPasswordForm';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createLostPasswordScreen = () => {
  const root = createRoot(document.getElementById('lostPasswordPanel'));
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <LostPasswordPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createLostPasswordScreen = createLostPasswordScreen;
export { namespace, FORM_ID };
